<template>
  <div class="page" id="game">
    <img class="banner" src="~@/assets/header-img_02.jpg" />
    <div class="qna">
      <div
        class="questions"
        v-for="(item, index) in quesList"
        :key="index"
        v-show="index == curQues"
      >
        <div class="topinfo flex">
          <div class="questions_tag">{{ item.question_type }}</div>
          <div class="questions_num" :data-options="item.options + '1'">
            <span style="font-size:26px;">{{ index + 1 }}</span>
            /{{ quesList.length }}
          </div>
        </div>
        <div class="question">
          {{ item.question_content }}
          <div class="ques_image ques_type2" v-if="item.question_type2 == '图文题'">
            <img :src="item.imgurl" style="width:100%" @click="imgShow(item.imgurl)" />
          </div>
          <div class="ques_audio ques_type2" v-if="item.question_type2 == '音频题'">
            <audio controls :src="item.imgurl" style="width: 100%;"></audio>
          </div>
          <div class="ques_video ques_type2" v-if="item.question_type2 == '视频题'">
            <video
              id="VideoPlay"
              webkit-playsinline
              playsinline
              x5-playsinline
              controls
              preload="auto"
              controlslist="nodownload"
              :poster="item.videoimg"
              :src="item.imgurl"
              type="video/mp4"
              style="width: 100%;height:100%;"
            ></video>
          </div>
          <!-- :poster="'https://activity.sznews.com/'+item.videoimg" -->
        </div>

        <!-- {{item}} -->
        <div
          class="option_bar flex"
          v-for="(option, oindex) in item.options"
          :key="oindex"
          @click="onChoose(oindex)"
          v-show="option.value ? option.value.trim() : ''"
        >
          <div class="dot" :class="option.chosen ? 'dot_hover' : ''">{{ option.key }}</div>
          {{ option.value }}
        </div>

        <van-button
          type="primary"
          size="large"
          round
          block
          color="#e2353f"
          class="next_btn"
          @click="toNextQues"
        >{{ btnText }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
